import type { ReactNode } from "react";

export type BuilderStudioTopbarProps = {
  actions?: ReactNode;
  appearance?: "studio" | "workspace";
  brand?: ReactNode;
  className?: string;
  context?: ReactNode;
  navigation?: ReactNode;
  navigationClassName?: string;
  secondary?: ReactNode;
  secondaryClassName?: string;
  status?: ReactNode;
};

export function BuilderStudioTopbar({
  actions,
  appearance = "studio",
  brand,
  className = "",
  context,
  navigation,
  navigationClassName = "max-w-28 sm:max-w-none sm:shrink-0",
  secondary,
  secondaryClassName = "",
  status,
}: BuilderStudioTopbarProps) {
  return (
    <header
      className={[
        "relative z-[110] w-full max-w-full shrink-0 overflow-visible shadow-sm",
        appearance === "workspace"
          ? "glass text-text"
          : "border-b border-[#303241] bg-[#252838] text-white",
        className,
      ].filter(Boolean).join(" ")}
      data-builder-studio-topbar="true"
    >
      <div
        className={[
          "flex h-14 w-full min-w-0 items-center justify-between gap-1 sm:gap-3",
          appearance === "workspace" ? "px-2 sm:px-6" : "px-4",
        ].join(" ")}
      >
        <div className="flex h-full min-w-0 flex-1 items-center gap-1 sm:gap-4">
          {brand ? (
            <div
              className={[
                "flex shrink-0 items-center",
                appearance === "workspace" ? "-ml-2 h-full sm:-ml-6" : "gap-2",
              ].join(" ")}
              data-builder-studio-topbar-brand="true"
            >
              {brand}
            </div>
          ) : null}
          {navigation ? (
            <div
              className={["min-w-0", navigationClassName].filter(Boolean).join(" ")}
              data-builder-studio-topbar-navigation="true"
            >
              {navigation}
            </div>
          ) : null}
          {context ? (
            <div className="hidden min-w-0 lg:block" data-builder-studio-topbar-context="true">
              {context}
            </div>
          ) : null}
        </div>

        <div className="flex min-w-0 shrink-0 items-center justify-end gap-1 sm:gap-2">
          {status ? (
            <div className="flex min-w-0 items-center gap-1 sm:gap-2" data-builder-studio-topbar-status="true">
              {status}
            </div>
          ) : null}
          {actions ? (
            <div className="flex min-w-0 items-center gap-1 sm:gap-2" data-builder-studio-topbar-actions="true">
              {actions}
            </div>
          ) : null}
        </div>
      </div>

      {secondary ? (
        <div
          className={[
            appearance === "workspace"
              ? "border-t border-border bg-surface/80 backdrop-blur-xl"
              : "border-t border-white/10 bg-[#202332]",
            secondaryClassName,
          ].filter(Boolean).join(" ")}
          data-builder-studio-topbar-secondary="true"
        >
          {secondary}
        </div>
      ) : null}
    </header>
  );
}
